import { render } from "./MobileStartUp.vue?vue&type=template&id=8dfba9a0&scoped=true&ts=true"
import script from "./MobileStartUp.vue?vue&type=script&lang=ts"
export * from "./MobileStartUp.vue?vue&type=script&lang=ts"

import "./MobileStartUp.vue?vue&type=style&index=0&id=8dfba9a0&lang=less&scoped=true"

import exportComponent from "/Users/neal/Desktop/www/qingtv/qingtv-back-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dfba9a0"]])

export default __exports__